<!-- src/components/CharactersList.vue -->
<template>
  <div class="full-screen-background">
    <v-container class="pa-4 animator">
      <h2 class="text-center animator">{{ t('characters.title') }}</h2>
      <div class="mb-4 text-center animator">
        <strong>{{ t('characters.youHave', { count: info.count }) }}</strong>
      </div>

      <div v-if="info.characters.length">
        <v-row dense justify="center" align="center">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="character in info.characters"
            :key="character.id"
          >
            <v-card class="animator elevation-2 text-center infoGame">
              <v-card-title class="justify-center">
                {{ character.given_name }}
              </v-card-title>
              <v-card-text>
                <div class="mb-2">
                  <strong>{{ t('characters.classLabel') }}</strong>
                  {{ getClassName(character.class_id) }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.levelLabel') }}</strong>
                  {{ character.level }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.goldLabel') }}</strong>
                  {{ character.gold }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.silverLabel') }}</strong>
                  {{ character.silver }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.bronzeLabel') }}</strong>
                  {{ character.bronze }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.createdLabel') }}</strong>
                  {{ formatDate(character.create_time) }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.rebirthsLabel') }}</strong>
                  {{ character.rebirth_count }}
                </div>
                <div class="mb-2">
                  <strong>{{ t('characters.bannedLabel') }}</strong>
                  {{ character.banido ? t('characters.yes') : t('characters.no') }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-else class="text-center animator">
        {{ t('characters.noCharacters') }}
      </div>
    </v-container>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchCharacters } from '../services/api'
import { auth } from '../auth'
import { useI18n } from 'vue-i18n'

// Importa o JSON das classes (considerando que este componente está em views/)
import classesData from './jsonClasses/classes.json'

const { t } = useI18n()

// Mapa de id → nome para lookup rápido
const classMap = {}
classesData.forEach(c => {
  classMap[c.id] = c.name
})

const info = ref({ count: 0, characters: [] })

// formata a data no padrão brasileiro
const formatDate = (iso) => {
  const d = new Date(iso)
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// retorna o nome da classe a partir do id
const getClassName = (id) => {
  return classMap[id] || `Desconhecido (${id})`
}

onMounted(async () => {
  try {
    const res = await fetchCharacters(auth.token)
    if (res.count !== undefined) {
      info.value = res
    } else {
      console.error(res.error || 'Erro desconhecido')
    }
  } catch (e) {
    console.error('Falha ao carregar personagens:', e)
  }
})
</script>

<style scoped>
.infoGame {
  /* uma sobreposição branca meio translúcida */
  background-color: rgba(0, 0, 0, 0.336);
  padding: 1rem;          /* opcional, para dar espaçamento interno */
  border-radius: 0.5rem;  /* opcional, só pra ficar mais bonito */
}
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
.animator {
  /* efeito simples de fade-in e slide-up */
  animation: fadeInUp 0.5s ease-out both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
